import script from "./BackToTop.vue?vue&type=script&setup=true&lang=ts"
export * from "./BackToTop.vue?vue&type=script&setup=true&lang=ts"

import "./BackToTop.vue?vue&type=style&index=0&id=090c351e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-090c351e"]])

export default __exports__